import { Container } from 'inversify'

import { VolleyballIncidentId } from '@collector/sportsapi-client-legacy'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindAssignableIncidentConfiguration(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.AssignableIncidentsConfiguration)
    .toDynamicValue(() => {
      return {
        [VolleyballIncidentId.ServiceAce]: {
          participants: { main: 'Server', secondary: 'Receiver' },
          participantsConfiguration: {
            secondary: {
              loadOppositeTeam: true,
            },
          },
        },
        [VolleyballIncidentId.ServiceError]: {
          participants: { main: 'Server' },
        },
        [VolleyballIncidentId.AttackPoint]: {
          participants: { main: 'Scorer' },
        },
        [VolleyballIncidentId.AttackError]: {
          participants: { main: 'Attacker' },
        },
        [VolleyballIncidentId.BlockPoint]: {
          participants: { main: 'Blocker', secondary: 'Attacker' },
          participantsConfiguration: {
            secondary: {
              loadOppositeTeam: true,
            },
          },
        },
        [VolleyballIncidentId.TechnicalErrors]: {
          participants: { main: 'Player' },
        },
        [VolleyballIncidentId.Point]: {
          participants: { main: 'Scorer' },
        },
        [VolleyballIncidentId.Serve]: {
          participants: { main: 'Server' },
        },
        [VolleyballIncidentId.NeutralAttack]: {
          participants: { main: 'Attacker' },
        },
        [VolleyballIncidentId.Reception]: {
          participants: { main: 'Receiver' },
        },
        [VolleyballIncidentId.Dig]: {
          participants: { main: 'Defender' },
          participantsConfiguration: {
            main: {
              optional: true,
            },
          },
        },
        [VolleyballIncidentId.Set]: {
          participants: { main: 'Setter' },
          participantsConfiguration: {
            main: {
              optional: true,
            },
          },
        },
        [VolleyballIncidentId.Cards]: {
          participants: { main: 'Player' },
        },
      }
    })
    .inSingletonScope()
}
